import React from 'react';

// PowerBI component for displaying a button to access a Power BI application
// It accepts an appUrl and an optional appName prop to customize the button's behavior and appearance
// The button opens the Power BI application in a new browser tab when clicked
const PowerBI = ({ appUrl, appName = "Power BI App" }) => {
  
  // Function to handle button click
  // It opens the specified appUrl in a new tab with 'noopener,noreferrer' for security
  // This prevents the new page from having access to the original page's window object
  const handleClick = () => {
    window.open(appUrl, '_blank', 'noopener,noreferrer');
  };
  return (
    <div className='powerBi'
      style={{
        textAlign: 'center',
        padding: '20px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        margin: '20px',
        maxWidth: '600px',
        margin: '20px auto'
      }}>
      <h2>Access {appName}</h2>
      <p>
        Click the button below to open the Power BI application in a new browser tab.
      </p>
      <button
        onClick={handleClick}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          backgroundColor: '#0078D4',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginTop: '15px'
        }}
      >
        Open {appName}
      </button>
      <p style={{ fontSize: '0.8em', color: '#666', marginTop: '15px' }}>
        (This will open a new tab/window and requires you to be logged into Power BI.)
      </p>
    </div>
  );
};
export default PowerBI;